module.exports = __webpack_public_path__ + "img/sj_jiancai.5ee2c608.jpg";